import authService from "../../api/services/authService";
import permissionService from "../../api/services/permission.service";
import { usePermissionStore } from '../permissions'
// Create a new store instance.
const auth = {
    state: {
        user: localStorage.getItem('user') || null,
        token: localStorage.getItem('token') || null,
      },
      mutations: {
        setUsuario(state, user) {
          state.user = user;
          localStorage.setItem('user', user); 
        },
        setToken(state, token) {
          state.token = token;
          localStorage.setItem('token', token); // Armazena o token no localStorage
        },
        logout(state) {
          state.usuario = null;
          state.token = null;
          localStorage.removeItem('token'); // Remove o token ao deslogar
        },
      },
      actions: {
        
        async login({ commit }, { email, password }) {
          try {
            const data = await authService.login(email, password)
            commit('setUsuario', data.user);
            commit('setToken', data.access_token);

            const permissionStore = usePermissionStore();
            const userPermissions = await permissionService.getUserPermissions(data.user_id);
        
            permissionStore.setPermissions(userPermissions.data.data.map(p => p.name));

          } catch (error) {
            console.error('Erro no login:', error);
            throw error;
          }
        },

        login2({ commit }, { email, password }) {
            
            authService.login(email, password).then(response => {
                console.log('login');
                console.log(response);
            })
            .catch(() => {
                console.log("Erro no login");
            });
              
          },


        logout({ commit }) {
          commit('logout');
        },
      },
      getters: {
        isAuthenticated(state) {
          return !!state.token;
        },
      },
      persist: true
    
   
}

// const app = createApp({ /* your root component */ })


export default auth;
